import React from 'react';
import { Input, Tag, Tooltip } from 'antd';
import { ModalTagContainer } from '../../components/Modals/styles';
import { AppStoreContext } from '../../context/appStoreContext';
class AddTags extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      inputVisible: true,
      inputValue: '',
      isLoading: true,
      borderVisibility: false,
      isvalidTag: true,
    };
  }

  static contextType = AppStoreContext;

  handleClose = removedTag => {
    const tags = this.state.tags.filter(tag => tag !== removedTag);
    this.setState({ tags });
    this.props.globalTagSearch(tags);
  };

  handleInputChange = e => {
    let { tags } = this.state;
    let tagTestStatus;
    let trimedTag = e.target.value.trim().replace(/\s/g, '');
    let exists = tags.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
    if (exists) {
      tagTestStatus = false;
    } else {
      tagTestStatus = true;
    }
    this.setState({
      inputValue: e.target.value,
      borderVisibility: true,
      isvalidTag: tagTestStatus,
    });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.state;
    let trimedTag = inputValue.trim();
    if (trimedTag.length > 0) {
      let exists = tags.some(tag => tag.toLowerCase() === trimedTag.toLowerCase());
      if (!exists) {
        tags.push(trimedTag);
      } else {
        // message.error(t('message.tagAlreadyExists'));
      }
    }
    this.setState({
      tags,
      inputValue: '',
    });
    let updatedTags = JSON.parse(JSON.stringify(tags));
    this.props.globalTagSearch(updatedTags);
  };

  componentDidMount() {
    const { target } = this.props;
    let tagArray;
    if (target && target.tags) {
      tagArray = target.tags.split(',');
    } else {
      tagArray = [];
    }
    this.setState({
      isLoading: false,
      tags: tagArray,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { tags } = this.state;
    const { clearALLTags } = this.props;
    if (prevState.tags !== tags) {
      this.setState({
        isvalidTag: true,
      });
    }
    if (prevProps.clearALLTags !== clearALLTags) {
      this.setState({
        tagArray: [],
        tags: [],
      });
      this.props.globalTagSearch([], true);
    }
  }

  handleInputFocus = () => {
    this.setState({
      borderVisibility: true,
    });
  };

  handleInputOutofFocus = () => {
    // this.handleInputConfirm();
    this.setState({
      borderVisibility: false,
    });
  };

  render() {
    const { placeholder } = this.props;
    const { tags, inputValue, isLoading } = this.state;

    return (
      <div onKeyDown={e => e.stopPropagation()} style={{ width: '100%' }}>
        {!isLoading && (
          <ModalTagContainer tagSearch={true}>
            {tags.map((tag, index) => {
              const isLongTag = tag.length > 20;
              const tagElem = (
                <Tag
                  className="edit-tag"
                  key={tag}
                  closable={true}
                  onClose={() => this.handleClose(tag)}
                  color="#df4c35"
                >
                  <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                </Tag>
              );
              return isLongTag ? (
                <Tooltip title={tag} key={tag}>
                  {tagElem}
                </Tooltip>
              ) : (
                tagElem
              );
            })}
            <Input
              name="tagName"
              type="text"
              className="tag-input"
              value={inputValue}
              onFocus={this.handleInputFocus}
              onChange={this.handleInputChange}
              onBlur={this.handleInputOutofFocus}
              onPressEnter={this.handleInputConfirm}
              placeholder={placeholder}
              autoComplete={'off'}
            />
          </ModalTagContainer>
        )}
      </div>
    );
  }
}

export default AddTags;
